export const LogoMark = ({ size = 34 }) => (
    <img
        src="/assets/kryvo-mark.png"
        alt="Kryvo logo"
        style={{ height: size, width: "auto" }}
        className="object-contain"
    />
);

export const Logo = ({ compact = false }) =>
    compact ? (
        <LogoMark />
    ) : (
        <img
            src="/assets/kryvo-logo.png"
            alt="Kryvo AI CRM"
            className="h-9 w-auto object-contain"
        />
    );
